namespace AsyncFn {
  export const deferrable = <Args extends any[], R, Extensions = {}>(
    fn: (...args: Args) => Promise<(() => R) & Extensions>
  ) =>
    Object.assign(
      (...args: Args) => fn(...args).then((resolve) => resolve()),
      {
        defer: fn,
      },
      // Include properties attached to the original function
      fn
    );
}

export default AsyncFn;
